module.exports = __webpack_public_path__ + "static/media/4.cca5f733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/4.jpg
// module id = 195
// module chunks = 0